import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface RichTextEditorProps {
  value: string;
  onChange: (content: string) => void;
  setCountCharacters?: (count: number) => void;
  placeholder?: string;
  error?: string;
  label?: string;
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  setCountCharacters,
  placeholder = 'Start typing...',
  error,
  label
}) => {
  // Define toolbar options
  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['link']
    ]
  };

  // Define formats that are allowed
  const formats = [
    'bold', 'italic', 'underline',
    'list', 'bullet',
    'link'
  ];

  const handleChange = (content: string) => {
    onChange(content);

    // Only count the relevant characters. Richtext has a lot of extra characters like html tags. these are ignored
    if (setCountCharacters) {
      const relevantContent = content.replace(/<[^>]*>?/g, '').trim();
      setCountCharacters(relevantContent.length);
    }
  };

  return (
    <div className="w-full font-sans">
      {label && (
        <label>{label}</label>
      )}

      {/* <div className={`richtext ${error ? 'error' : ''}`}> */}
      <ReactQuill
        value={value}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        theme="snow"
      />
      {/* </div> */}

      {error && (
        <div className="mt-2 text-sm text-red-500">{error}</div>
      )}
    </div>
  );
};

export default RichTextEditor;